// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as ApolloConfig from "../../core/ApolloConfig.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation updateVariant_purchasePrice($id: ID!, $input: InputUpdateVariant!)  {\nupdateVariant(id: $id, input: $input)  {\n__typename  \nid  \npurchasedPrice  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.purchasedPrice;
  return {
    updateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      purchasedPrice: !(value$2 == null) ? value$2 : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.purchasedPrice;
  let purchasedPrice = value$2 !== undefined ? value$2 : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let updateVariant = {
    __typename: value$4,
    id: value$3,
    purchasedPrice: purchasedPrice
  };
  return {
    updateVariant: updateVariant
  };
}

function serializeInputObjectInputUpdateVariantMetaData(inp) {
  let a = inp.shopifyVariantId;
  return {
    shopifyVariantId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputUpdateVariant(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.name;
  let a$2 = inp.purchasedPrice;
  let a$3 = inp.year;
  let a$4 = inp.capacityValue;
  let a$5 = inp.capacityUnit;
  let a$6 = inp.capacityPrecision;
  let a$7 = inp.alcoholVolume;
  let a$8 = inp.ean13;
  let a$9 = inp.internalNote;
  let a$10 = inp.metadata;
  let a$11 = inp.tastingNote;
  let a$12 = inp.packaging;
  let a$13 = inp.internalCode;
  let a$14 = inp.priceLookUpCode;
  let a$15 = inp.supplierId;
  let a$16 = inp.minStockThreshold;
  let a$17 = inp.maxStockThreshold;
  let a$18 = inp.stockOrderTriggerThreshold;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: a$1 !== undefined ? a$1 : undefined,
    purchasedPrice: a$2 !== undefined ? a$2 : undefined,
    year: a$3 !== undefined ? a$3 : undefined,
    capacityValue: a$4 !== undefined ? a$4 : undefined,
    capacityUnit: a$5 !== undefined ? a$5 : undefined,
    capacityPrecision: a$6 !== undefined ? a$6 : undefined,
    alcoholVolume: a$7 !== undefined ? a$7 : undefined,
    ean13: a$8 !== undefined ? a$8 : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    metadata: a$10 !== undefined ? serializeInputObjectInputUpdateVariantMetaData(a$10) : undefined,
    tastingNote: a$11 !== undefined ? a$11 : undefined,
    packaging: a$12 !== undefined ? a$12 : undefined,
    internalCode: a$13 !== undefined ? a$13 : undefined,
    priceLookUpCode: a$14 !== undefined ? a$14 : undefined,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    minStockThreshold: a$16 !== undefined ? a$16 : undefined,
    maxStockThreshold: a$17 !== undefined ? a$17 : undefined,
    stockOrderTriggerThreshold: a$18 !== undefined ? a$18 : undefined
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateVariant(inp.input)
  };
}

function makeVariables(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateVariant(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, internalNote, metadata, tastingNote, packaging, internalCode, priceLookUpCode, supplierId, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    internalNote: internalNote,
    metadata: metadata,
    tastingNote: tastingNote,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    supplierId: supplierId,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}

function makeInputObjectInputUpdateVariantMetaData(shopifyVariantId, param) {
  return {
    shopifyVariantId: shopifyVariantId
  };
}

let VariantPurchasePriceMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let VariantPurchasePriceMutation_useWithVariables = include.useWithVariables;

let VariantPurchasePriceMutation = {
  VariantPurchasePriceMutation_inner: VariantPurchasePriceMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData,
  use: use,
  useWithVariables: VariantPurchasePriceMutation_useWithVariables
};

function PricePurchaseTableEditCell(props) {
  let onChange = props.onChange;
  let __autoFocused = props.autoFocused;
  let variantId = props.variantId;
  let minRetailPrice = props.minRetailPrice;
  let value = props.value;
  let autoFocused = __autoFocused !== undefined ? __autoFocused : false;
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutation = match[1];
  let mutate = match[0];
  let match$1 = React.useState(() => {});
  let setOptimisticValue = match$1[1];
  let optimisticValue = match$1[0];
  let debouncedValue = ReactUpdateDebounced.use(optimisticValue, ApolloConfig.mutationDebounceInterval);
  let onMutatePurchasePriceRequested = React.useCallback(purchasePrice => {
    let input = makeInputObjectInputUpdateVariant(undefined, undefined, purchasePrice, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    Future.get(FuturePromise.fromPromise(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: variantId,
      input: input
    })), response => {
      if (response.TAG === "Ok") {
        let match = response._0;
        if (match.TAG === "Ok" && match._0.error === undefined) {
          return;
        }
      }
      setOptimisticValue(param => {});
    });
  }, []);
  React.useEffect(() => {
    if (!mutation.loading && debouncedValue !== undefined && optimisticValue !== undefined && value !== optimisticValue) {
      onMutatePurchasePriceRequested(debouncedValue);
    }
  }, [debouncedValue]);
  let onChange$1 = React.useCallback(value => {
    if (onChange !== undefined) {
      onChange(value);
    }
    setOptimisticValue(param => value);
  }, []);
  let onBlur = Stdlib_Option.map(props.onBlur, onBlur => (() => {
    if (optimisticValue !== undefined && value !== optimisticValue) {
      onMutatePurchasePriceRequested(optimisticValue);
    }
    onBlur();
  }));
  let errorMessage = minRetailPrice !== undefined && value > minRetailPrice && minRetailPrice !== 0 ? I18n.t("The purchase price shouldn't exceed the entered retail prices.") : undefined;
  return JsxRuntime.jsx(InputNumberField.make, {
    value: Stdlib_Option.getOr(optimisticValue, value),
    minValue: 0,
    precision: 3,
    errorMessage: errorMessage,
    appender: {
      TAG: "Custom",
      _0: I18n.toCurrencySymbol("EUR") + Stdlib_Option.mapOr(props.bulkUnit, "", unit => ` / ` + unit)
    },
    shrinkInput: true,
    autoFocused: autoFocused,
    onChange: onChange$1,
    onFocus: props.onFocus,
    onBlur: onBlur
  });
}

let make = React.memo(PricePurchaseTableEditCell, (oldProps, newProps) => {
  if (oldProps.value === newProps.value && oldProps.minRetailPrice === newProps.minRetailPrice && oldProps.bulkUnit === newProps.bulkUnit) {
    return oldProps.variantId === newProps.variantId;
  } else {
    return false;
  }
});

export {
  VariantPurchasePriceMutation,
  make,
}
/* query Not a pure module */
